/**
 * Copyright (c) 2023 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : locale_fr.jsx
 * description   : {{insert here}}
 * creation date : 11/11/2023
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    locale_msg,
} from '@/utils/locale/enums';



// --------------------------------------------------------------------------------
//      CONSTANTS DEFINITION
// --------------------------------------------------------------------------------

const fr_FR =
{
    [locale_msg.COGNITO_AUTH__SIGN_IN__HEADER]: 'Connectez-vous à votre compte',
    [locale_msg.COGNITO_AUTH__SIGN_IN__TAB]: 'Se connecter',
    [locale_msg.COGNITO_AUTH__SIGN_IN__BUTTON]: 'Se connecter',
    [locale_msg.COGNITO_AUTH__SIGN_IN__TRY]: 'Connexion en cours',
    [locale_msg.COGNITO_AUTH__SIGN_IN__RESET_PASSWORD]: 'Réinitialiser le mot de passe',

    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__HEADER]: 'Créer un nouveau compte',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__TAB_AND_BUTTON]: 'S\'inscrire',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__TRY]: 'Création d\'un compte',
    [locale_msg.COGNITO_AUTH__CREATE_ACCOUNT__BACK_TO_SIGN_IN]: 'Retour à la connexion',

    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__HEADER]: 'Code de confirmation',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__CONFIRM]: 'Confirmer',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__CONFIRMING]: 'Confirmation en cours',
    [locale_msg.COGNITO_AUTH__CONFIRM_CREATE_ACCOUNT__RESEND_CODE]: 'Renvoyer le code',

    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__HEADER]: 'Réinitialiser le mot de passe',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__SEND_CODE]: 'Envoyer le code',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__SENDING]: 'Envoi en cours',
    [locale_msg.COGNITO_AUTH__RESET_PASSWORD__BACK_TO_SIGN_IN]: 'Retour à la connexion',

    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__HEADER]: 'Réinitialiser le mot de passe',
    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__SUBMIT]: 'Envoyer',
    [locale_msg.COGNITO_AUTH__CONFIRM_RESET_PASSWORD__SUBMITTING]: 'Envoi en cours',

    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__HEADER]: 'Réinitialiser le mot de passe',
    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__CHANGE_PASSWORD]: 'Envoyer',
    [locale_msg.COGNITO_AUTH__FORCE_NEW_PASSWORD__CHANGING]: 'Envoi en cours',

    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__HEADER]: 'Vérifiez votre adresse e-mail',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__VERIFY]: 'Vérifier',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__VERIFYING]: 'Vérification en cours',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__SKIP]: 'Passer',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__EMAIL]: 'Adresse e-mail',
    [locale_msg.COGNITO_AUTH__VALIDATE_PASSWORD__CODE]: 'Code de confirmation',

    [locale_msg.COGNITO_AUTH__CONFIRM_VALIDATE_PASSWORD__HEADER]: 'Vérifiez votre adresse e-mail',

    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__EMAIL]: 'Adresse e-mail :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NAME]: 'Prénom :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__FAMILY_NAME]: 'Nom de famille :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NICKNAME]: 'Entreprise :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__PHONE_NUMBER]: 'Numéro de téléphone :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__PASSWORD]: 'Mot de passe :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRM_PASSWORD]: 'Confirmer le mot de passe :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRMATION_CODE]: 'Code de confirmation :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__NEW_PASSWORD]: 'Nouveau mot de passe :',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__LABEL__CONFIRM_NEW_PASSWORD]: 'Confirmez le mot de passe :',

    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__EMAIL]: 'Saisissez votre adresse e-mail',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NAME]: 'Saisissez votre prénom',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__FAMILY_NAME]: 'Saisissez votre nom de famille',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NICKNAME]: 'Saisissez votre entreprise',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__PHONE_NUMBER]: 'Saisissez votre no. de téléphone',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__PASSWORD]: 'Saisissez votre mot de passe',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRM_PASSWORD]: 'Veuillez confirmer votre mot de passe',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRMATION_CODE]: 'Saisissez le code de confirmation',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__NEW_PASSWORD]: 'Saisissez votre nouveau mot de passe',
    [locale_msg.COGNITO_AUTH__AUTH_FORM_TEXT__PLACEHOLDER__CONFIRM_NEW_PASSWORD]: 'Confirmez votre nouveau mot de passe',

    [locale_msg.GENERAL__COPYRIGHT]: 'Tous droits réservés',
    [locale_msg.GENERAL__LOG_IN]: 'Se connecter',
    [locale_msg.GENERAL__LOG_OUT]: 'Se déconnecter',
};



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    fr_FR,
};



// End of file
